import { apiService } from './api';
import type { Category } from '../types';

export class ResourceTopicService {
  private baseUrl = '/api/resource-topics';

  async getTopics(params?: {
    page?: number;
    pageSize?: number;
  }): Promise<{ categories: Category[]; totalCount: number; page: number; pageSize: number; totalPages: number }> {
    const searchParams = new URLSearchParams();
    if (params?.page) searchParams.append('page', params.page.toString());
    if (params?.pageSize) searchParams.append('pageSize', params.pageSize.toString());
    
    const queryString = searchParams.toString();
    const endpoint = queryString ? `${this.baseUrl}?${queryString}` : this.baseUrl;
    
    const response = await apiService.get(endpoint);
    
    // Backend returns same structure as categories API
    return response as { categories: Category[]; totalCount: number; page: number; pageSize: number; totalPages: number };
  }

  async getTopicById(id: string): Promise<Category> {
    return apiService.get<Category>(`${this.baseUrl}/${id}`);
  }

  async createTopic(topicData: { name: string; description?: string }): Promise<Category> {
    return apiService.post<Category>(this.baseUrl, topicData);
  }

  async updateTopic(id: string, topicData: { name: string; description?: string }): Promise<Category> {
    return apiService.put<Category>(`${this.baseUrl}/${id}`, topicData);
  }

  async deleteTopic(id: string): Promise<void> {
    return apiService.delete<void>(`${this.baseUrl}/${id}`);
  }
}

export const resourceTopicService = new ResourceTopicService();
export default resourceTopicService;

